import { StampShapes } from '../../types/api/stamp'

export const stampShapes: StampShapes[] = ['Прямоугольный', 'Квадрат', 'Круг', 'Овал', 'Фигурный']
